<form [formGroup]="loginForm" (ngSubmit)="onConnect()" class="dashboard-tile mat-elevation-z4">
    <div class="tile-header">
      <div class="tile-header-title">
        Connect SSO User
      </div>
    </div>
    <div class="tile-content">
      <img mat-card-image class="tile-logo" src="/assets/icons/large/large_icon_login.svg" >
      <div>Your ConnectWise SSO account has been verified but it is not currently connected to your Identify account. If you would like to use SSO to access Identify, please enter your Identify credentials and click the "Connect" button, otherwise click "Cancel" to return to the login screen.</div>

      <div *ngIf="loginForm.errors">
        <mat-error *ngIf="loginForm?.errors?.invalidUser">Invalid username/password</mat-error>
      </div>
      <div class="formFieldList">
        <mat-form-field>
          <input matInput placeholder="Enter your email" formControlName="email" required autocomplete="email">
        </mat-form-field>
        <mat-form-field>
          <input formControlName="password" matInput placeholder="Password" type="password" required autocomplete="password">
        </mat-form-field>
      </div>
  
      <div class="tile-footer centered">
          <button mat-button color="primary" type="button" (click)="onCancel()">Cancel</button>
          <button mat-raised-button color="primary" type="submit">Connect</button>
      </div>
    </div>
  </form>